module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides clearfix"
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('airportProducts.headerTopTextPresentation')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.headerTopSubTextPresentation')))])]), _vm._v(" "), _c('div', {
    staticClass: "right-box",
    class: {
      'show': _vm.showText
    }
  }, [_c('div', {
    staticClass: "vertical-middle"
  }, [_c('div', {
    staticClass: "right-box-content"
  }, [_c('div', {
    staticClass: "number",
    class: 'current-' + _vm.currentStep,
    attrs: {
      "id": "bigNumber"
    }
  }, [_c('div', {
    staticClass: "numbers"
  }, _vm._l((_vm.steps.length), function(i) {
    return _c('span', [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].title))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn orange next-step",
    class: {
      'visible': _vm.currentStep !== _vm.steps.length
    },
    attrs: {
      "id": "playButton"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.next'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "last-step",
    class: {
      'visible': _vm.currentStep === _vm.steps.length
    }
  }, [_c('div', {
    staticClass: "btn-hover"
  }, [_c('div', {
    staticClass: "btn orange",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.ask')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn red-border",
    attrs: {
      "to": "/products/airport"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.learnMore'))), _c('span')])], 1)])])])])])]), _vm._v(" "), _c('FooterOrange')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-267698a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AirportPresentation.vue
// module id = 284
// module chunks = 0